import * as React from "react";
import {
  TextField,
  EditButton,
  TextInput,
  FunctionField,
  SelectInput,
} from "react-admin";
import { StatusEnum } from "../../../common/enum";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";

const listFilters = [
  <TextInput source="search" label="Search" alwaysOn />,
  <SelectInput source="status" choices={StatusEnum} />,
];

export const TaxClassList = (props) => (
  <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <FunctionField
        label="Status"
        render={(record) =>
          StatusEnum.find((x) => x.id === record.status)?.name
        }
      />
      <IfCanAccess action="edit">
        <EditButton />
      </IfCanAccess>
    </Datagrid>
  </List>
);
